// extracted by mini-css-extract-plugin
export var skipAnimation = "_22-0";